import fetch from "auth/FetchInterceptor";

const loginQuotesService = {};

loginQuotesService.get = function () {
	return fetch({
		url: "/v1/rest/login-quotes",
		method: "get",
		headers: { "public-request": true },
	});
};

loginQuotesService.getById = function (id) {
	return fetch({
		url: "/v1/rest/login-quotes/" + id,
		method: "get",
	});
};

loginQuotesService.create = function (data) {
	return fetch({
		url: "/v1/rest/login-quotes",
		method: "post",
		data: data,
	});
};

loginQuotesService.update = function (id, data) {
	return fetch({
		url: "/v1/rest/login-quotes/" + id,
		method: "put",
		data: data,
	});
};

loginQuotesService.delete = function (id) {
	return fetch({
		url: "/v1/rest/login-quotes/" + id,
		method: "delete",
	});
};

export default loginQuotesService;
